/**
 * Route KML loader module
 * Handles loading and setup of route KML layers (walking, cycling, wheelchair, riders)
 */

import loadKml from './kml-loader.js'
import createPopup from './create-popup.js'

/**
 * Create a popup description from route layer properties
 */
function createRoutePopupDescription(layer) {
  let markeringString = ''

  if (layer.feature.properties.Markering) {
    markeringString += `Markering: ${layer.feature.properties.Markering.toLowerCase()}`

    if (layer.feature.properties.Kleurpopup) {
      markeringString += `, ${layer.feature.properties.Kleurpopup.toLowerCase()}`
    }

    markeringString += `<br>`
  }

  const extraInfoString = layer.feature.properties.Extrapopup ? layer.feature.properties.Extrapopup : ''

  return `
    ${parseFloat(layer.feature.properties.Kilometer, 10).toFixed(1)} KM<br>
    ${markeringString}
    ${extraInfoString}
  `
}

/**
 * Setup popup and click handlers for a route layer
 */
function setupRouteLayer(layer) {
  const popup = createPopup({
    Title: layer.feature.properties.Object,
    Description: createRoutePopupDescription(layer),
  })

  layer.bindPopup(popup)
  layer.addEventListener('click', () => {
    layer.openPopup()
  })
}

/**
 * Load a route KML layer and setup popups/events
 * @param {string} kmlUrl - URL to the KML file
 * @param {Object} map - Leaflet map instance
 * @returns {Object|null} - The KML layer or null if URL is not provided
 */
export function loadRouteKmlLayer(kmlUrl, map) {
  if (!kmlUrl) return null

  const kmlLayer = loadKml(kmlUrl)

  kmlLayer.addEventListener('ready', () => {
    kmlLayer.eachLayer((layer) => {
      setupRouteLayer(layer)
    })
  })

  return kmlLayer
}

